import Style from "../utility/style"

const definedStyles = [
    ["color", "Color"],
    ["swiss", "Swiss"]
]

const styleIds = []
const styles = {}

for(var i = 0; i < definedStyles.length; i++) {
    styleIds.push(definedStyles[i][0])
    styles[definedStyles[i][0]] = new Style(definedStyles[i][0], definedStyles[i][1])
}

function writeStyleIndexToStorage(styleIndex)
{
    if (window.localStorage) {
        window.localStorage.setItem("singular-key-style", styleIds[styleIndex])
    }
    
}

function readStyleIndexFromStorage()
{
    if (window.localStorage) {
        const style = window.localStorage.getItem("singular-key-style")
        if (style !== null && style !== undefined) {
            for (var i = 0; i < styleIds.length; i++) {
                if (styleIds[i] === style) {
                    return i
                }
            }
        }
    }
    return 0
}

class StyleStorage
{
    constructor()
    {
        this.element = document.createElement("link")
        this.element.setAttribute("rel", "stylesheet")
        document.getElementsByTagName("head")[0].appendChild(this.element)
        this.styleIndex = readStyleIndexFromStorage()
        this.write()
    }

    nextStyle()
    {
        this.styleIndex = (this.styleIndex + 1) % styleIds.length
        this.write()
    }

    getAllStyles()
    {
        return styleIds.map(styleId => styles[styleId])
    }

    selectStyle(style)
    {
        for (var i = 0; i < styleIds.length; i++) {
            if (styleIds[i] === style) {
                this.styleIndex = i
                this.write()
                return
            }
        }
    }

    getSelectedStyle()
    {
        return styleIds[this.styleIndex]
    }

    getStyle(styleId = null)
    {
        if (styleId === null || styleId === undefined) {
            styleId = this.getSelectedStyle()
        }
        return styles[styleId]
    }

    write()
    {
        writeStyleIndexToStorage(this.styleIndex)
        this.element.setAttribute("href", "styles/" + this.getSelectedStyle() + ".css")
    }
}

export default new StyleStorage
